<template lang="pug">
w-btn-icon.w-btn-close( v-bind='{ size, hover, hoverAction }' v-on='$listeners' )
  i-close( title='close' )
</template>

<script lang="js">
import IClose from 'icons/Close'
import WBtnIcon, { mixin } from './w-btn-icon'

export default {
  name: 'CloseButtonWidget',
  mixins: [ mixin ],
  components: { WBtnIcon, IClose },
  props: {
    size: {
      type: String,
      default: 'xl',
    }
  },
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {}
}
</script>

<style lang="scss">
.w-btn-icon.w-btn-close {
  position: absolute;
  display: block;
  top: 0;
  right: 0;
  height: var(--s-close-button, var(--s-2xl));
  width: var(--s-close-button, var(--s-2xl));
  padding: var(--pad-close-button, var(--s-base));
  color: var(--c-close-button, var(--c-button, white ));
  border: 0 none;
  background: transparent;
  opacity: 0.5;
  box-sizing: content-box;
  transition: 400ms all;
  z-index: 10;
  text-shadow: 0 0 2px var(--c-btn-shadow);
  svg {
    transition: 400ms all;
    filter: drop-shadow( 0 0 1px var(--c-btn-shadow));
  }
  &:hover, &:focus {
    transition: all 150ms;
    opacity: 1;
    outline: 0 none !important;
    color: white;
    text-shadow: var(--glow-hover);
    svg {
      filter: var(--glow-svg-hover);
    }
  }
  &:active {
    text-shadow: var(--glow-active);
    box-shadow: none;
    svg {
      filter: var(--glow-svg-active);
    }
  }
  .icon {
    height: 1em;
    width: 1em;
    font-size: var(--s-close-button, var(--s-2xl));
  }
}
</style>
